import React, { useState, useEffect } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import apiService from '../../utils/api'; 
import './ProjectEmailPopup.css';
import { CustomSelect } from './CreateBlankModal'; 
import Snackbar from '@mui/material/Snackbar'; 

const VendorPopup = ({ isOpen, onClose, onSave }) => {
  const [vendorName, setVendorName] = useState('');
  const [vendorEmail, setVendorEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [userId, setUserId] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);

  useEffect(() => {
    const storedUserId = sessionStorage.getItem('user_id') || '';
    setUserId(storedUserId);
  }, []);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!vendorName || !vendorEmail) {
      setSnackbarMessage('Please fill all required fields');
      setIsSuccess(false);
      setSnackbarOpen(true);
      return;
    }

    const payload = {
      vendorName: vendorName,
      vendorEmail: vendorEmail,
      created_by: userId,
    };

    console.log("Submitting vendor payload:", payload);

    try {
      setIsLoading(true);
      const res = await apiService.postData("vendor", payload);
      console.log("Vendor API Response:", res);
      if (res?.status === "success" || res?.vendor_id) {
        const newVendor = {
          vendor_id: res?.vendor_id || res?.data?.vendor_id || Date.now().toString(),
          vendorName: vendorName,
          vendorEmail: vendorEmail,
        };
        setSnackbarMessage('Vendor added successfully');
        setIsSuccess(true);
        setSnackbarOpen(true);
        setVendorName('');
        setVendorEmail('');
        if (onSave) {
          onSave(newVendor);
        }
        
        // Close snackbar after 1 second and then close modal
        setTimeout(() => {
          setSnackbarOpen(false);
          onClose();
        }, 1000);
      } else {
        setSnackbarMessage(res?.message || 'Failed to save vendor');
        setIsSuccess(false);
        setSnackbarOpen(true);
      }
    } catch (error) {
      console.error("Error saving vendor:", error);
      setSnackbarMessage('Error saving vendor: ' + error.message);
      setIsSuccess(false);
      setSnackbarOpen(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="cbm-modal-header">
          <h2>Add New Vendor</h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Vendor Name <span className="required-asterisk">*</span></label>
            <input
              type="text"
              value={vendorName}
              onChange={(e) => setVendorName(e.target.value)}
              placeholder="Enter vendor name"
              required
            />
          </div>
          <div className="form-group">
            <label>Vendor Email <span className="required-asterisk">*</span></label>
            <input
              type="email"
              value={vendorEmail}
              onChange={(e) => setVendorEmail(e.target.value)}
              placeholder="Enter vendor email"
              required
            />
          </div>

          <div className="client-form-actions">
            <button type="submit" className="modal-action-btn modal-action-btn-save" disabled={isLoading}>
              {isLoading ? (
                <>
                  <CircularProgress size={20} style={{ marginRight: '8px', color: 'white' }} />
                  Saving...
                </>
              ) : (
                "Save"
              )}
            </button>
            <button
              type="button"
              className="modal-action-btn modal-action-btn-cancel"
              onClick={onClose}
              disabled={isLoading}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
      
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={1000}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        sx={{
          '& .MuiSnackbarContent-root': {
            backgroundColor: isSuccess ? '#4caf50' : '#f44336',
          },
          zIndex: 1400,
        }}
      />
    </div>
  );
};

export default VendorPopup;
